import { Box } from '@mui/material';
import { ChangeEvent, FC, useState } from 'react';

import CustomButton from 'components/CustomButton';
import CustomInput from 'components/CustomInput';
import ManagementSubheader from 'components/ManagementSubheader';
import NewCustomerModal from 'containers/POSPage/NewCustomerModal';

interface POSHeaderProps {
  onSearch: (searchTerm: string) => void;
}

const PosHeader:FC<POSHeaderProps> = ({ onSearch }) => {
  const [openNewCustomerModal, setOpenNewCustomerModal] = useState(false);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setCustomerSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <ManagementSubheader title="Visitor Queue">
      <Box display="flex" justifyContent="flex-end" alignItems="center" flexGrow={1} gap={2}>
        <CustomInput
          size="small"
          value={customerSearchTerm}
          onChange={handleSearch}
          placeholder="Search customers by name"
        />

        <CustomButton id="button-createNewOrder" variant="outlined">
          Create New Order
        </CustomButton>

        <CustomButton id="button-createNewCustomer" onClick={() => setOpenNewCustomerModal(true)}>
          Create New Customer
        </CustomButton>

        {openNewCustomerModal && (
          <NewCustomerModal onClose={() => setOpenNewCustomerModal(false)} />
        )}
      </Box>
    </ManagementSubheader>
  );
};

export default PosHeader;
